import './Projects.css';
import ProjectsCatalog from '../components/ProjectsPage/ProjectsCatalog/ProjectsCatalog';
import { projects } from '../data/projects';

const Projects = () => {
  return (
    <main className="section projects-page">
      <div className="container">
        <h1 className="title-1 projects-page__title">Примеры проектов</h1>
        <ProjectsCatalog projects={projects} />
      </div>
    </main>
  );
};

export default Projects;
